export const createNonTaskDateHtml = (dateStr, onlyRead) => `
  <span className="vertical-center-dates" style="cursor: ${onlyRead ? 'not-allowed' : 'pointer'}">
    <span className="column-disabled">${dateStr}</span>
  </span>
`;

export const createTaskDateHtml = (dateStr, onlyRead, isOdd) => `
  <div class="${isOdd ? 'odd-col' : 'non-odd-col'}" style="cursor: ${onlyRead ? 'not-allowed' : 'pointer'}">
    ${dateStr}
  </div>
`;
